import * as React from 'react';

import FileDicom32 from './FileDicom32';

export const fileDicom32 = () => <FileDicom32 />;

export default {
    title: 'Icon|Content|FileDicom32',
    component: FileDicom32,
    parameters: {
        notes: "`import FileDicom32 from 'box-ui-elements/es/icon/content/FileDicom32';`",
    },
};
